import * as React from 'react';

import { ProjectDiagramCreateClassDrawer } from 'src/containers/ProjectDiagram/components/classDrawer/ProjectDiagramCreateClassDrawer';
import { CreateMappingDialog } from 'src/containers/ProjectDiagram/components/dialogs/CreateMappingDialog';
import { ProjectDiagramCreateRelationshipDrawer } from 'src/containers/ProjectDiagram/components/relationshipDrawer/ProjectDiagramCreateRelationshipDrawer';
import { ProjectDiagramCreateSensitivePropertyGroupDrawer } from 'src/containers/ProjectDiagram/components/sensitivePropertyGroupDrawer/ProjectDiagramCreateSensitivePropertyGroupDrawer';
import { ProjectFileUploadPreviewDialog } from 'src/containers/ProjectFileUploadPreviewDialog/ProjectFileUploadPreviewDialog';
import { ProjectFileUploadPreviewDialog as ProjectFileUploadPreviewDialogV2 } from 'src/containers/ProjectFileUploadPreviewDialogV2/ProjectFileUploadPreviewDialog';
import { ProjectMappingSettingsDrawer } from 'src/containers/ProjectMappingSettingsDrawer/ProjectMappingSettingsDrawer';
import { ProjectModelDialog } from 'src/containers/ProjectModelDialog/ProjectModelDialog';
import { RenameProjectModelDialog } from 'src/containers/ProjectModelDialog/RenameProjectModelDialog';
import { ProjectNewResourceDialog as ProjectNewResourceDialogV2 } from 'src/containers/ProjectNewResourceDialogV2/ProjectNewResourceDialog';
import { ProjectResourceDialog } from 'src/containers/ProjectResourceDialog/ProjectResourceDialog';
import { ProjectResourceSuggestionsDialog } from 'src/containers/ProjectResourceSuggestionsDialog/ProjectResourceSuggestionsDialog';
import { ProjectRuleDetailDrawer } from 'src/containers/ProjectRuleDetailDrawer/ProjectRuleDetailDrawer';
import { ProjectSettingsDrawer } from 'src/containers/ProjectSettingsDrawer/ProjectSettingsDrawer';
import { ProjectVirtualGraphPreviewDialog } from 'src/containers/ProjectVirtualGraphPreviewDialog/ProjectVirtualGraphPreviewDialog';
import { ProjectVirtualGraphPreviewDialog as ProjectVirtualGraphPreviewDialogV2 } from 'src/containers/ProjectVirtualGraphPreviewDialogV2/ProjectVirtualGraphPreviewDialog';
import { PublishProjectDrawer } from 'src/containers/PublishProjectDrawer/PublishProjectDrawer';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const ProjectOverlays: React.VFC = () => {
  const newProjectResourceFlow = useReduxSelector(
    (state) => state.features.app.newProjectResourceFlow
  );

  return (
    <>
      <ProjectDiagramCreateClassDrawer />
      <ProjectDiagramCreateRelationshipDrawer />
      <ProjectDiagramCreateSensitivePropertyGroupDrawer />

      <ProjectRuleDetailDrawer />

      <ProjectMappingSettingsDrawer />
      <ProjectSettingsDrawer />
      <PublishProjectDrawer />

      <ProjectModelDialog />
      <RenameProjectModelDialog />
      {newProjectResourceFlow ? (
        <ProjectNewResourceDialogV2 />
      ) : (
        <ProjectResourceDialog />
      )}

      {newProjectResourceFlow ? (
        <ProjectFileUploadPreviewDialogV2 />
      ) : (
        <ProjectFileUploadPreviewDialog />
      )}

      {newProjectResourceFlow ? (
        <ProjectVirtualGraphPreviewDialogV2 />
      ) : (
        <ProjectVirtualGraphPreviewDialog />
      )}

      <CreateMappingDialog />
      <ProjectResourceSuggestionsDialog />
    </>
  );
};
